import { render, staticRenderFns } from "./ConfiguracionEditar.vue?vue&type=template&id=48f6e78c"
import script from "./ConfiguracionEditar.vue?vue&type=script&lang=js"
export * from "./ConfiguracionEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports